import { useQueryClient } from "@tanstack/react-query";
import { useLayoutEffect } from "react";

import { useContentHostId } from "../../backend/index.ts";
import { nodeRemovedEventName, subscribeEvent, unsubscribeEvent } from "../../events/index.ts";
import { getScreenshotQueryKey } from "./queryKeys.ts";

interface Options {
  filter: Parameters<typeof nodeRemovedEventName>;
}

// this looks unnecessary but because we can re-use node ids after a node is deleted
// we need to clear the cache entries. the server side will clean up via events
// TEMP: filter is probably premature perf optimisation;
export const useScreenshotCleanup = ({ filter }: Options) => {
  const queryClient = useQueryClient();
  const hostId = useContentHostId();

  useLayoutEffect(() => {
    const token = subscribeEvent(nodeRemovedEventName(...filter), ({ id }) => {
      // for those who have not read tanstack query docs this includes the hash because it shares this key
      queryClient.removeQueries({ queryKey: getScreenshotQueryKey(hostId, id) });
    });
    return () => {
      unsubscribeEvent(token);
    };
  }, [filter, hostId, queryClient]);
};
